import React, { useCallback } from 'react';
import { useIdleTimeout } from '../hooks/useIdleTimeout';
import { useUser } from '../context/UserContext';
import SessionWarningModal from './popups/SessionWarningModal';
import useNetworkStatus from '../hooks/useNetworkStatus';
import NetworkBanner from './NetworkBanner';

interface SessionManagerProps {
  children: React.ReactNode;
}

/**
 * Manages session timeout
 * Wrap your app with this to enable 30-day idle timeout
 */
const SessionManager: React.FC<SessionManagerProps> = ({ children }) => {
  const { isAuthenticated } = useUser();

  const handleBeforeLogout = useCallback(async () => {
    // no-op: hook requires callback
  }, []);

  const {
    showWarning,
    secondsRemaining,
    extendSession,
    logout,
  } = useIdleTimeout({
    onBeforeLogout: handleBeforeLogout,
  });

  const { showBanner, bannerType } = useNetworkStatus();

  return (
    <>
      <NetworkBanner showBanner={showBanner} bannerType={bannerType} />
      {children}
      {isAuthenticated && showWarning && (
        <SessionWarningModal
          isOpen={showWarning}
          secondsRemaining={secondsRemaining}
          onExtendSession={extendSession}
          onLogout={logout}
        />
      )}
    </>
  );
};

export default SessionManager;
